import React, {useState} from 'react';
import {
  AutoSizer,
  CellMeasurer,
  CellMeasurerCache,
  Grid as VirtualizedGrid,
} from "react-virtualized";
import TableCell from "@material-ui/core/TableCell";

import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";

import Colors from "../../Styles/Colors";
import Texts from "../../Styles/Texts";

const useStyles = makeStyles((theme) => ({
    cellHeader: {
      color: Colors.black,
      backgroundColor: Colors.primaryUltraLight
      // position: "sticky",
      // top: 0,
      // zIndex: 10
    },
    headerRow: {
      position: 'fixed', 
      top: 0

    },
    cellRow: {
      color: Colors.grayHigh,
      backgroundColor:  Colors.white,
      
    },
    cellRowSelected: {
      backgroundColor: Colors.secondaryUltraLight,      
    }
}));

export default function TableVirtualizedSelected({ headerRow = [], rows=[], showCounter=true, tableHeight=500, rowSelected, setRowSelected}) {
    const classes = useStyles();
    //const [rowSelected,setRowSelected] = useState(null);


  // console.log('rows:', rows);

  function cellRenderer({ columnIndex, key, parent, rowIndex, style }) {
      

    return (


            <CellMeasurer
              cache={cache}
              columnIndex={columnIndex}
              key={key}
              parent={parent}
              rowIndex={rowIndex}
            >


             

                  <TableCell
                    component={"span"}
                    style={style}
                    onClick={(e) => rowIndex === 0 ? setRowSelected(null) : setRowSelected(rowIndex)}
                    className={rowIndex == 0 ? classes.cellHeader : rowIndex === rowSelected ? classes.cellRowSelected : classes.cellRow}
                  >
                    
                   {rows[rowIndex][columnIndex]}
                  </TableCell>
                  
            </CellMeasurer>      
    );
  }

  const cache = new CellMeasurerCache({
    defaultWidth: 100,
    minWidth: 75,
    fixedHeight: false,
    minHeight: 20,
  });


  // var headerRow = {};


  // console.log('headerRow',headerRow);

  return (
    <div>
    <Typography variant="h6"
        color="inherit"
        noWrap className={classes.contResultsLabel}>Results Found: {rows.length == 0 ? 0 : rows.length-1}
    </Typography>

    <AutoSizer>

      {({ height, width }) => (


        <VirtualizedGrid
          style={{ borderRadius: "5px" }}
          cellRenderer={cellRenderer}
          columnCount={rows.length == 0 ? 0 : rows[0].length}
          columnWidth={cache.columnWidth}
          height={tableHeight}
          rowCount={rows.length}
          rowHeight={cache.rowHeight}
          width={width}

        />
      )}

    </AutoSizer>

    </div>
  );
}
